import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BsGrid3X3GapFill, BsListStars } from 'react-icons/bs';
import { FaMapMarkedAlt } from 'react-icons/fa';
import { IoBookmarkOutline } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import BannerImageAd from '../../Component/BannerImageAd';
import BreadCrumb from '../../Component/BreadCrumb';
import Button from '../../Component/Button/Button';
import DropDown from '../../Component/DropDown/DropDown';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import { Loader } from '../../Component/Loader';
import NoData from '../../Component/NoData/NoData';
import { PaginationComponent } from '../../Component/Pagination/Pagination';
import ProjectCard from '../../Component/ProjectCard';
import ProjectFilters from '../../Component/ProjectFilters';
import ProjectHorizontalCard from '../../Component/ProjectHorizontalCard/ProjectHorizontalCard';
import Tabs from '../../Component/Tabs';
import Tooltip from '../../Component/Tooltip';
import MapMain from '../../Component/maps/MapMain';
import { isMobileViewHook } from '../../CustomHooks/isMobileViewHook';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import {
  discardUndefinedOrNullValues,
  imageUrl,
  recordsLimit15,
  showTabsWhenUserIsLogin
} from '../../config/apiUrl';
import { projectFilterOptions, roomsOptions } from '../../constant/commonData';
import EmailAgentModal from '../../modals/EmailAgentModal';
import SaveSearchModal from '../../modals/SaveSearchModal/SaveSearchModal';
import { useGetPublicProjectsMutation, usePostApiMutation } from '../../store/apiSlice/apiSlice';
import {
  bannerConditions,
  convertAreaIfNotInMeterSqaure,
  generateBanners,
  otherToUsd
} from '../../utils/helpers';
import classes from './projects.module.css';


function Projects() {
  const {  unitTypes, projectStatus, interiorAmenities, exteriorAmenities } =
    useSelector((state) => state?.commonReducer);
  const { t } = useTranslation('projects');
  const { isLogin, user } = useSelector((state) => state.authReducer);
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { allBanners } = useSelector((state) => state.commonReducer);
  const { areaUnit, currency } = useSelector((state) => state.converterReducer);
  const isSavedFilter = useLocation()?.state;
  const [getProjects, { isLoading, data }] = useGetPublicProjectsMutation();
  const [isMobile, setIsMobile] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState('');
  const [mapProperties, setMapProperties] = useState(data?.data ?? []);
  useEffect(() => {
    if (data?.data) {
      setMapProperties(data?.data);
    }
  }, [data]);

  const [page, setPage] = useState(1);
  const [selectedItem, setSelectedItem] = useState(null);
  const [filters, setFilters] = useState({
    province: null,
    neighborhood: null,
    town: null,
    entity: null,
    nearby: null,
    search: '',
    minPrice: '',
    maxPrice: '',
    maxArea: null,
    minArea: null,
    noOfRooms: null,
    address: '',
    lng: '',
    lat: '',
    date: '',
    sortBy: null, // Add sortBy here
    sortType: null,
    unitType: null,
    projectStatus: null,
    interiorAmenities: [],
    exteriorAmenities: []
  });
  const routeName = 'projects';
  const [isSticky, setIsSticky] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [showSaveSearch, setShowSaveSearch] = useState(false);
  const [saveSearchLoading, setSaveSearchLoading] = useState(false);
  const [postApiFunc] = usePostApiMutation();

  const verticalAd = allBanners?.filter(
    (item) => item?.page === 'projects' && item?.bannerType == 'vertical'
  );



  const getFilterModifyData = (fil) => {
    const filterData = {
      address: fil?.address,
      lan: selectedLanguage,
      province: fil?.province?._id,
      town: fil?.town?._id,
      neighborhood: fil?.neighborhood?._id,
      entity: fil?.entity?._id,
      nearby: !!fil?.nearby,
      ...(fil?.nearby || filters?.address
        ? {
            lng: fil?.lng,
            lat: fil?.lat
          }
        : {}),
      minPrice: fil?.minPrice ? otherToUsd({ amount: fil?.minPrice, ...currency }) : '',
      maxPrice: fil?.maxPrice ? otherToUsd({ amount: fil?.maxPrice, ...currency }) : '',
      minArea: fil?.minArea ? convertAreaIfNotInMeterSqaure(fil?.minArea, areaUnit) : '',
      maxArea: fil?.maxArea ? convertAreaIfNotInMeterSqaure(fil?.maxArea, areaUnit) : '',
      noOfRooms: fil?.noOfRooms?.[selectedLanguage],
      minDate: fil?.date?.[0]?.startDate,
      maxDate: fil?.date?.[0]?.endDate,
      unitType: fil?.unitType?._id,
      projectStatus: fil?.projectStatus?._id,
      interiorAmenities: fil?.interiorAmenities?.map((e) => e?._id),
      exteriorAmenities: fil?.exteriorAmenities?.map((e) => e?._id)
      // address: filters?.address
    };

    return filterData;
  };
  const filtersToSearchParams = (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') return;

      if (Array.isArray(value)) {
        // Check if array contains objects
        const isObjectArray = value.some((item) => typeof item === 'object');
        if (isObjectArray) {
          params.set(key, JSON.stringify(value)); // Store whole array as JSON
        } else {
          params.set(key, value.join(',')); // Store primitive arrays as comma-separated
        }
      } else if (typeof value === 'object') {
        params.set(key, JSON.stringify(value)); // Store single object
      } else {
        params.set(key, value); // Primitive
      }
    });

    return params;
  };

  const searchParamsToFilters = (params) => {
    const filters = {};

    for (const [key, value] of params.entries()) {
      try {
        const parsed = JSON.parse(value);
        filters[key] = parsed;
      } catch {
        if (value.includes(',')) {
          filters[key] = value.split(',').map((v) => {
            try {
              return JSON.parse(v);
            } catch {
              return v;
            }
          });
        } else {
          filters[key] = value;
        }
      }
    }

    return filters;
  };

  // Data For Filter
  const handleGetProjects = async (pg = page, filData = getFilterModifyData(filters)) => {
    // same as property component functionality

    if (filData.address && Array.isArray(filData.address)) {
      filData = { ...filData, address: filData.address.join(',') };
    }

    const searchParams = filtersToSearchParams(filData);
    window.history.replaceState({}, '', `?${searchParams.toString()}`);

    await getProjects({
      page: pg,
      limit: recordsLimit15,
      data: {
        lan: selectedLanguage,
        ...discardUndefinedOrNullValues(filData)
      }
    });
  };

  const handleSaveSearch = async (title = '') => {
    const referenceObj = {
      title,
      province: filters?.province?._id,
      town: filters?.town?._id,
      neighborhood: filters?.neighborhood?._id,
      unitType: filters?.unitType?._id,
      projectStatus: filters?.projectStatus?._id,
      exteriorAmenities: filters?.exteriorAmenities?.map((a) => a?._id),
      interiorAmenities: filters?.interiorAmenities?.map((a) => a?._id)
    };
    const filterData = {
      nearby: filters?.nearby,
      ...(filters?.nearby || filters?.address
        ? {
            lng: filters?.lng,
            lat: filters?.lat
          }
        : {}),
      minPrice: filters?.minPrice ? Number(filters?.minPrice) : '',
      maxPrice: filters?.maxPrice ? Number(filters?.maxPrice) : '',
      noOfRooms: filters?.noOfRooms,
      minArea: filters?.minArea ? convertAreaIfNotInMeterSqaure(filters?.minArea, areaUnit) : '',
      maxArea: filters?.maxArea ? convertAreaIfNotInMeterSqaure(filters?.maxArea, areaUnit) : '',
      // maxDate: filters?.date?.[0]?.endDate,
      address: filters?.address
    };

    let ifFilterHasSelected = Object.keys(
      discardUndefinedOrNullValues({
        ...referenceObj,
        ...filterData
      })
    );

    if (ifFilterHasSelected?.length === 0) {
      toast.warn(t('toast.noFilter'));
      return;
    }
    if (data?.data?.length === 0) {
      toast.warn(t('toast.noData'));
      return;
    }

    if (isLoading) {
      toast.warn(t('toast.loading'));
      return;
    }

    setSaveSearchLoading(true);

    const response = await postApiFunc({
      url: `savedSearch`,
      method: 'POST',
      tag: `savedSearch`,

      data: discardUndefinedOrNullValues({
        data: discardUndefinedOrNullValues(filterData),
        ...referenceObj,
        type: 'project',
        pathName: window.location.pathname
      })
    });
    if (response?.data) {
      toast.success(t('toast.createdSuccessfully'));
      handleGetProjects(page);
    }
    setShowSaveSearch(false);
    setSaveSearchLoading(false);
  };

  useEffect(() => {
    if (isSavedFilter) {
      let newData = {
        ...isSavedFilter,
        minPrice: isSavedFilter?.minPrice ? Number(isSavedFilter?.minPrice) : '',
        maxPrice: isSavedFilter?.maxPrice ? Number(isSavedFilter?.maxPrice) : ''

        // date: [
        //   {
        //     startDate: isSavedFilter?.minDate ? new Date(isSavedFilter?.minDate) : null,
        //     endDate: isSavedFilter?.maxDate ? new Date(isSavedFilter?.maxDate) : null,
        //     key: 'selection'
        //   }
        // ]
      };
      delete newData?.minDate;
      delete newData?.maxDate;
      setFilters((prev) => ({
        ...prev,
        ...newData
      }));
      handleGetProjects(1, getFilterModifyData(newData));
    }
  }, [isSavedFilter]);

 

  useEffect(() => {
    if (isSavedFilter) return;
    const params = new URLSearchParams(window.location.search);
    if ([...params.keys()].length > 0) {
      const urlFilters = searchParamsToFilters(params);

      setFilters((prev) => ({
        ...prev,
        // ...urlFilters

        unitType: unitTypes?.find((a) => a?._id === urlFilters?.unitType),
        projectStatus: projectStatus?.find((a) => a?._id === urlFilters?.projectStatus) || null,
        minPrice: urlFilters?.minPrice ? Number(urlFilters?.minPrice) : '',
        maxPrice: urlFilters?.maxPrice ? Number(urlFilters?.maxPrice) : '',

        minArea: urlFilters?.minArea
          ? convertAreaIfNotInMeterSqaure(urlFilters?.minArea, areaUnit)
          : '',
        maxArea: urlFilters?.maxArea
          ? convertAreaIfNotInMeterSqaure(urlFilters?.maxArea, areaUnit)
          : '',
        noOfRooms: roomsOptions?.find((a) => a?.[selectedLanguage] === urlFilters?.noOfRooms),
        exteriorAmenities: exteriorAmenities?.filter(
          (a) =>
            urlFilters?.exteriorAmenities?.includes(a?._id) ||
            a?._id === urlFilters?.exteriorAmenities
        ),
        interiorAmenities: interiorAmenities?.filter(
          (a) =>
            urlFilters?.interiorAmenities?.includes(a?._id) ||
            a?._id === urlFilters?.interiorAmenities
        ),
        address: Array.isArray(urlFilters?.address)
          ? urlFilters?.address?.join(',').trim()
          : urlFilters?.address?.trim()
      }));

      setTimeout(() => {
        handleGetProjects(1, urlFilters);
      }, 0);
    } else {
      handleGetProjects();
    }
  }, []);

  const handleSearch = async () => {
  
    handleGetProjects(1);
  };
  const horizontalBanners = generateBanners({
    allBanners,
    routeName,
    page
  });

  const saveSearchData = showTabsWhenUserIsLogin(isLogin, [
    {
      icon: (
        <Tooltip text={t('tabs.saveSearch')}>
          <IoBookmarkOutline size={20} color="var(--primary-clr)" />
        </Tooltip>
      ),
      text: t('tabs.saveSearch'),
      value: 'save-search',
      id: '4'
    }
  ])[0];

  const tabsData = isMobile
    ? [
        {
          icon: (
            <Tooltip text={'Map'}>
              <FaMapMarkedAlt size={22} color="var(--arrowColor)" />
            </Tooltip>
          ),
          value: 'map',
          tooltipText: t('tabs.map'),
          id: '3'
        }
        // saveSearchData
      ]
    : [
        {
          icon: <BsGrid3X3GapFill size={20} color="var(--arrowColor)" />,
          tooltipText: t('tabs.grid'),
          value: 'grid',
          id: '1'
        },
        {
          icon: <BsListStars size={22} color="var(--arrowColor)" />,
          tooltipText: t('tabs.list'),
          value: 'list',
          id: '2'
        },
        {
          icon: <FaMapMarkedAlt size={22} color="var(--arrowColor)" />,
          value: 'map',
          tooltipText: t('tabs.map'),
          id: '3'
        }
        // ,saveSearchData
      ];
  const [selectedTab, setSelectedTab] = useState(tabsData[1]);

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setSelectedTab({ text: 'list', id: '2' });
    }
  }, [isMobile]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsSticky(scrollTop > 90); // Adjust threshold as needed
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={classes.page}>
      <Header containerClass="" />

      <div className={[classes.filtersDiv, isSticky && classes.sticky].join(' ')}>
        <ProjectFilters
          containerClass=""
          showOneLine
          filtersWrapperClass={classes.filters}
          t={t}
          onSearch={handleSearch}
          filters={filters}
          setFilters={setFilters}
          setSearchText={setSearchText}
          searchText={searchText}
          savedSearch={isSavedFilter}
          disabledSearch={isLoading}
        />
      </div>
    
      <Container className={classes.contentContainer} fluid={selectedTab?.value === 'map'}>
        <Row className={classes.mainRow}>
          <Col md={5} className={classes.dataLeftStrip}>
            <BreadCrumb
              data={[
                {
                  title: 'Home',
                  path: '/'
                },
                {
                  title: 'Projects',
                  active: true
                }
              ]}
            />
            <p className={classes.tabsDiv__highlight2}>
              {data?.totalRecords ?? 0} {t('tabs.title')}
            </p>
          </Col>
          <Col md={7}>
            {/* filter */}
            <div className={classes?.dataStripRight}>
              {/* <span>{t('sortBy')}</span> */}
              <DropDown
                borderRadius="35px"
                classNamePrefix={'smDropdown'}
                className={classes?.dropdown}
                options={projectFilterOptions}
                value={projectFilterOptions.find((option) => option.value === filters.sortType)}
                setValue={(e) => {
                  setFilters((prevFilters) => ({
                    ...prevFilters,
                    sortType: e?.value // Set sortBy in the state
                  }));
                  setPage(1);
                  handleGetProjects(1, { ...filters, sortType: e?.value }); // Call handleGetProjects with updated filters
                }}
                optionLabel={[selectedLanguage]}
                optionValue={'value'}
                placeholder={t('sortBy')}
                customStyle={{
                  height: '44px',
                  fontSize: '14px'
                }}
              />
              {saveSearchData && (
                <Button
                  borderRadius="50px"
                  label={saveSearchData?.text}
                  leftIcon={saveSearchData?.icon}
                  variant="white"
                  onClick={() => {
                    const isAllowedActions = restrictOnlyUserActions(user?.role);
                    if (!isAllowedActions) return;
                    setShowSaveSearch(true);
                    
                  }}
                  className={classes.saveButton}
                />
              )}
              <Tabs
                separatorColor="var(--white-clr)"
                tabClass={classes.tab}
                setValue={(e) => {
                  if (isMobile && e?.value === selectedTab?.value) {
                    setSelectedTab({ value: 'list' });
                  } else {
                    setSelectedTab(e);
                  }
                
                }}
                value={selectedTab}
                tabsData={tabsData}
              />
            </div>
          </Col>
          <Col
            md={selectedTab?.value == 'map' ? 12 : 10}
            className={[
              selectedTab?.value !== 'map' && 'verticalBannerAndContentWidth',
              classes.col1
            ].join(' ')}>
            {isLoading ? (
              <Loader className={classes?.loader} />
            ) : (
              <Row
                className={[classes.innerRow, selectedTab?.value == 'map' && classes.h100].join(
                  ' '
                )}>
                {/* --------------------- MAP View Start ----------------------- */}
                {selectedTab?.value == 'map' ? (
                  <>
                    <Col
                      xl={{ span: 5, order: 1 }}
                      xs={{ span: 12, order: 2 }}
                      className={`scroller ${classes.mapLisingCards}`}>
                      <Row className={classes.mapList}>
                        {/* {data?.data?.slice(0, 9)?.map((item, key) => ( */}
                        {mapProperties?.map((item, key) => (
                          <Col xl={6} lg={4} sm={6} key={`${item?._id}-${key}`}>
                            <ProjectCard
                              data={item}
                              onEmailClick={() => {
                                setIsModalOpen('email');
                              }}
                              refetch={handleGetProjects}
                            />
                          </Col>
                        ))}
                      </Row>
                    </Col>
                    <Col xl={{ span: 7, order: 2 }} xs={{ span: 12, order: 1 }}>
                      <MapMain
                        showLandMarks={false}
                        className={classes.mainMap}
                        mapClass={classes?.mapClass}
                        zoom={5.5}
                        mapProperties={data?.data}
                        setMapProperties={setMapProperties}
                        showMarker={false}
                      />
                    </Col>
                    {/* --------------------- MAP View End ----------------------- */}
                  </>
                ) : data?.data?.length == 0 ? (
                  <NoData text={t('noDataText')} />
                ) : (
                  data?.data?.map((item, key) => (
                    <>
                      <Col
                        md={selectedTab?.value == 'list' ? 12 : 6}
                        lg={selectedTab?.value == 'list' ? 12 : 4}
                        sm={12}
                        key={`${item?._id}-${key}`}>
                        {selectedTab?.value == 'list' ? (
                          <ProjectHorizontalCard
                            data={item}
                            index={`${item?._id}-${key}`}
                            className="mb-0"
                            onEmailClick={() => {
                              setSelectedItem(item);
                              setIsModalOpen('email');
                            }}
                            refetch={handleGetProjects}
                          />
                        ) : (
                          <ProjectCard
                            data={item}
                            onEmailClick={() => {
                              setSelectedItem(item);
                              setIsModalOpen('email');
                            }}
                            refetch={handleGetProjects}
                          />
                        )}
                      </Col>
                
                      {
                        
                        horizontalBanners?.length > 0 &&
                          bannerConditions[selectedTab?.value].renderCondition(key) && (
                            <Col md={12}>
                              <div className={classes?.bannerAdContainer}>
                                <BannerImageAd
                                  className={classes.horizontalBanner}
                                  image={imageUrl(
                                    horizontalBanners[bannerConditions.renderContentCondition(key)]
                                      .image
                                  )}
                                  link={
                                    horizontalBanners[bannerConditions.renderContentCondition(key)]
                                      ?.link
                                  }
                                />
                              </div>
                            </Col>
                          )
                      }
                    </>
                  ))
                )}
                {['list', 'grid'].includes(selectedTab?.value) && !!data?.data?.length && (
                  <Col md={12} className={[classes.pagination, 'jCenter'].join(' ')}>
                    <PaginationComponent
                      totalPages={Math.ceil(data?.totalRecords / recordsLimit15)}
                      currentPage={page}
                      setCurrentPage={(e) => {
                        setPage(e);
                        handleGetProjects(e);
                      }}
                    />
                  </Col>
                )}
              </Row>
            )}
          </Col>
          <Col
            md={2}
            className={[
              selectedTab?.value == 'map' && 'd-none',
              'verticalBannerWidth',
              classes.col2
            ].join(' ')}>
            <Row className={`${classes.bannerRow}`}>
              {/* {!isMobile && verticalAd?.[0]?.image && ( */}
              {verticalAd?.[0]?.image && (
                <Col md={12}>
                  <BannerImageAd
                    link={verticalAd?.[0]?.link}
                    image={imageUrl(verticalAd?.[0]?.image)}
                    className={classes.verticalBanner}
                  />
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
      <Footer />
      <EmailAgentModal
        show={isModalOpen == 'email'}
        setShow={setIsModalOpen}
        data={selectedItem}
        type={'project'}
        inquiryType={'inquiry'}
      />

      {showSaveSearch && (
        <SaveSearchModal
          show
          t={t}
          setShow={setShowSaveSearch}
          onClick={(title) => handleSaveSearch(title)}
          loading={saveSearchLoading}
        />
      )}
    </div>
  );
}

export default Projects;
